module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("市场管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("发布渠道收录表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "周期"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 2026-10 第四周"
    },
    model: {
      value: (_vm.queryParam.period),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "period", $$v)
      },
      expression: "queryParam.period"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊"
    },
    model: {
      value: (_vm.queryParam.personName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "personName", $$v)
      },
      expression: "queryParam.personName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.openChannelManage
    }
  }, [_vm._v("渠道管理")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableDataWithSum,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.queryParam.pageIndex,
      "page-size": _vm.queryParam.pageSize,
      "show-total": "",
      "show-sizer": "",
      "page-size-opts": [50, 100, 200]
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.formData.id ? '编辑' : '新增',
      "width": 520
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Form', {
    ref: "editForm",
    attrs: {
      "label-width": 100,
      "model": _vm.formData
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "周期",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 2026-10 第四周"
    },
    model: {
      value: (_vm.formData.period),
      callback: function($$v) {
        _vm.$set(_vm.formData, "period", $$v)
      },
      expression: "formData.period"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "姓名",
      "required": ""
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.personName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "personName", $$v)
      },
      expression: "formData.personName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.enabledChannels), function(ch) {
    return _c('Form-item', {
      key: ch.channelKey,
      attrs: {
        "label": ch.displayName
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 0
      },
      model: {
        value: (_vm.formData.channelValues[ch.channelKey]),
        callback: function($$v) {
          _vm.$set(_vm.formData.channelValues, ch.channelKey, $$v)
        },
        expression: "formData.channelValues[ch.channelKey]"
      }
    })], 1)
  }), _vm._v(" "), (!_vm.enabledChannels.length) ? _c('div', {
    staticStyle: {
      "color": "#999",
      "padding-left": "100px"
    }
  }, [_vm._v("请先在渠道管理中添加渠道")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "渠道管理",
      "width": 720
    },
    on: {
      "on-visible-change": _vm.onChannelVisible
    },
    model: {
      value: (_vm.showChannelModal),
      callback: function($$v) {
        _vm.showChannelModal = $$v
      },
      expression: "showChannelModal"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAddChannel
    }
  }, [_vm._v("新增渠道")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.channelColumns,
      "data": _vm.allChannels,
      "loading": _vm.channelLoading,
      "border": "",
      "stripe": "",
      "size": "small"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showChannelModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.channelForm.id ? '改名' : '新增渠道',
      "width": 480
    },
    model: {
      value: (_vm.showChannelEdit),
      callback: function($$v) {
        _vm.showChannelEdit = $$v
      },
      expression: "showChannelEdit"
    }
  }, [(_vm.channelForm.id) ? _c('Alert', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "type": "info",
      "show-icon": ""
    }
  }, [_vm._v("改名只影响展示，不影响已填数据。")]) : _vm._e(), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "展示名",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "列表列头"
    },
    model: {
      value: (_vm.channelForm.displayName),
      callback: function($$v) {
        _vm.$set(_vm.channelForm, "displayName", $$v)
      },
      expression: "channelForm.displayName"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "标识"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": !!_vm.channelForm.id,
      "placeholder": _vm.channelForm.id ? '' : '留空则自动生成'
    },
    model: {
      value: (_vm.channelForm.channelKey),
      callback: function($$v) {
        _vm.$set(_vm.channelForm, "channelKey", $$v)
      },
      expression: "channelForm.channelKey"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('Input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "placeholder": "默认追加到末尾"
    },
    model: {
      value: (_vm.channelForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.channelForm, "sort", $$v)
      },
      expression: "channelForm.sort"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showChannelEdit = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.channelSaving
    },
    on: {
      "click": _vm.saveChannel
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26001ee3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/ChannelIncludeList.vue
// module id = 1685
// module chunks = 8